import { HtmlSlideResource } from "./html_slide_resource";
import { IframeResource } from "./iframe_resource";
import { MinervaResource } from "./minerva_resource";
import { PdfResource } from "./pdf_resource";
import { ScreenshareResource } from "./screenshare_resource";
import { VideoResource } from "./video_resource";
import { WhiteboardResource } from "./whiteboard_resource";

import { ErrorMessage } from "components/shared/error_message";
import { useAppSelector } from "hooks/redux_hooks";
import { ResourceTypeType } from "shared/types";
import { classroomSelectors } from "store";
import { isVideoFile } from "utils/resource";

function ResourcePane({ resourceId }: { resourceId: string }) {
  const resource = useAppSelector(classroomSelectors.selectResourceById(resourceId));

  if (!resource) return null;

  const handleError = () => {
    window.flightLogger.error(`[ResourcePane] Unsupported resource type id=${resource.id}`);
    return <ErrorMessage message="Unsupported resource type" />;
  };

  return (
    <div className="w-full h-full" data-testid={`resource-pane-${resourceId}`}>
      {(() => {
        switch (resource.type) {
          case ResourceTypeType.GoogleDrive:
          case ResourceTypeType.Url:
            return <IframeResource key={resource.id} resource={resource} />;
          case ResourceTypeType.HtmlSlide:
            return <HtmlSlideResource key={resource.id} resource={resource} />;
          case ResourceTypeType.ForumDoc:
          case ResourceTypeType.ForumWorkbook:
            return <MinervaResource key={resource.id} resource={resource} />;
          case ResourceTypeType.Pdf:
            return <PdfResource key={resource.id} resource={resource} />;
          case ResourceTypeType.Whiteboard:
            return <WhiteboardResource key={resource.id} resource={resource} />;
          case ResourceTypeType.Video:
            return <VideoResource key={resource.id} resource={resource} />;
          case ResourceTypeType.Screenshare:
            return <ScreenshareResource key={resource.id} resource={resource} />;
          case ResourceTypeType.File:
            if (isVideoFile(resource.type, resource.url)) {
              return <VideoResource key={resource.id} resource={resource} />;
            }
            return handleError();
          default:
            return handleError();
        }
      })()}
    </div>
  );
}

export { ResourcePane };
